import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import styled from 'styled-components';

const ButtonGroup = ({ options, selectedOption, onSelect, onDeselect }) => (
  <ButtonContainer>
    {options.map((option) => (
      <Option
        onClick={() => {
          if (selectedOption === option.value) {
            onDeselect(option.value);
          } else {
            onSelect(option.value);
          }
        }}
        selected={selectedOption && selectedOption === option.value}
        key={option.label}
      >
        {option.label}
      </Option>
    ))}
  </ButtonContainer>
);

ButtonGroup.testProps = [
  {
    options: [
      {
        value: 'someVal',
        label: 'Hey Look',
      },
      {
        value: 'otherVal',
        label: "Hey Don't Look",
      },
    ],
  },
];

export default ButtonGroup;

const ButtonContainer = styled(Flex)`
  background-color: #e1e8ef;
  height: 35px;
  border-radius: 4px;
  padding-left: 7px;
  padding-right: 16px;
  justify-content: space-around;
  align-items: center;
`;

const Option = styled.button`
  appearance: none;
  border: none;
  padding: 0;
  background-color: transparent;
  width: 42px;
  height: 27px;
  border-radius: 6px;
  background-color: ${(props) => (props.selected ? '#f8fbff' : 'transparent')};
  font-size: 12px;
  font-weight: bold;
  color: ${(props) => (props.selected ? '#4597e0' : '#69829f')};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;
